import { render, staticRenderFns } from "./MPopupLayoutPreview.vue?vue&type=template&id=219d3864&"
import script from "./MPopupLayoutPreview.vue?vue&type=script&lang=ts&"
export * from "./MPopupLayoutPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports